var cov_2g6iiaykxs = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Transfer/Transfer.tsx",
      hash = "053a8a962173a602e66316d9f4347b4f9fe509a4",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Transfer/Transfer.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 21
        },
        end: {
          line: 24,
          column: 8
        }
      },
      "1": {
        start: {
          line: 20,
          column: 26
        },
        end: {
          line: 20,
          column: 27
        }
      },
      "2": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 16
        }
      },
      "3": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 39,
          column: 5
        }
      },
      "4": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 50
        }
      },
      "5": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 52
        }
      },
      "6": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 48
        }
      },
      "7": {
        start: {
          line: 46,
          column: 24
        },
        end: {
          line: 46,
          column: 34
        }
      },
      "8": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 53
        }
      },
      "9": {
        start: {
          line: 47,
          column: 32
        },
        end: {
          line: 47,
          column: 53
        }
      },
      "10": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 18
        }
      },
      "11": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 117
        }
      },
      "12": {
        start: {
          line: 52,
          column: 38
        },
        end: {
          line: 52,
          column: 117
        }
      },
      "13": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 31
        }
      },
      "14": {
        start: {
          line: 57,
          column: 31
        },
        end: {
          line: 57,
          column: 41
        }
      },
      "15": {
        start: {
          line: 58,
          column: 26
        },
        end: {
          line: 58,
          column: 36
        }
      },
      "16": {
        start: {
          line: 59,
          column: 25
        },
        end: {
          line: 59,
          column: 80
        }
      },
      "17": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 72
        }
      },
      "18": {
        start: {
          line: 61,
          column: 24
        },
        end: {
          line: 61,
          column: 72
        }
      },
      "19": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 65,
          column: 6
        }
      },
      "20": {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 92,
          column: 18
        }
      },
      "21": {
        start: {
          line: 93,
          column: 22
        },
        end: {
          line: 93,
          column: 40
        }
      },
      "22": {
        start: {
          line: 95,
          column: 24
        },
        end: {
          line: 95,
          column: 40
        }
      },
      "23": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 100,
          column: 5
        }
      },
      "24": {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 99,
          column: 49
        }
      },
      "25": {
        start: {
          line: 101,
          column: 20
        },
        end: {
          line: 101,
          column: 22
        }
      },
      "26": {
        start: {
          line: 102,
          column: 20
        },
        end: {
          line: 102,
          column: 22
        }
      },
      "27": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 110,
          column: 5
        }
      },
      "28": {
        start: {
          line: 104,
          column: 16
        },
        end: {
          line: 104,
          column: 23
        }
      },
      "29": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 109,
          column: 7
        }
      },
      "30": {
        start: {
          line: 106,
          column: 8
        },
        end: {
          line: 106,
          column: 23
        }
      },
      "31": {
        start: {
          line: 108,
          column: 8
        },
        end: {
          line: 108,
          column: 23
        }
      },
      "32": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 179,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 20,
            column: 14
          },
          end: {
            line: 20,
            column: 15
          }
        },
        loc: {
          start: {
            line: 20,
            column: 26
          },
          end: {
            line: 20,
            column: 27
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 57
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 33
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        loc: {
          start: {
            line: 45,
            column: 31
          },
          end: {
            line: 49,
            column: 3
          }
        },
        line: 45
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        loc: {
          start: {
            line: 51,
            column: 16
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 51
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 56,
            column: 56
          },
          end: {
            line: 66,
            column: 3
          }
        },
        line: 56
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        loc: {
          start: {
            line: 68,
            column: 11
          },
          end: {
            line: 180,
            column: 3
          }
        },
        line: 68
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 36,
            column: 18
          },
          end: {
            line: 38,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 37,
            column: 51
          }
        }, {
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 38,
            column: 70
          }
        }],
        line: 36
      },
      "1": {
        loc: {
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 38,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 38,
            column: 58
          }
        }, {
          start: {
            line: 38,
            column: 62
          },
          end: {
            line: 38,
            column: 70
          }
        }],
        line: 38
      },
      "2": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 53
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 53
          }
        }],
        line: 47
      },
      "3": {
        loc: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 117
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 117
          }
        }, {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 117
          }
        }],
        line: 52
      },
      "4": {
        loc: {
          start: {
            line: 52,
            column: 60
          },
          end: {
            line: 52,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 60
          },
          end: {
            line: 52,
            column: 83
          }
        }, {
          start: {
            line: 52,
            column: 87
          },
          end: {
            line: 52,
            column: 89
          }
        }],
        line: 52
      },
      "5": {
        loc: {
          start: {
            line: 59,
            column: 25
          },
          end: {
            line: 59,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 59,
            column: 33
          },
          end: {
            line: 59,
            column: 55
          }
        }, {
          start: {
            line: 59,
            column: 58
          },
          end: {
            line: 59,
            column: 80
          }
        }],
        line: 59
      },
      "6": {
        loc: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 61,
            column: 72
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 61,
            column: 72
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 61,
            column: 72
          }
        }],
        line: 61
      },
      "7": {
        loc: {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 70,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 70,
            column: 15
          },
          end: {
            line: 70,
            column: 34
          }
        }],
        line: 70
      },
      "8": {
        loc: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 36
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 75,
            column: 16
          },
          end: {
            line: 75,
            column: 36
          }
        }],
        line: 75
      },
      "9": {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 42
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 76,
            column: 19
          },
          end: {
            line: 76,
            column: 42
          }
        }],
        line: 76
      },
      "10": {
        loc: {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 87,
            column: 42
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 87,
            column: 19
          },
          end: {
            line: 87,
            column: 42
          }
        }],
        line: 87
      },
      "11": {
        loc: {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 88,
            column: 42
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 88,
            column: 19
          },
          end: {
            line: 88,
            column: 42
          }
        }],
        line: 88
      },
      "12": {
        loc: {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 42
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 89,
            column: 19
          },
          end: {
            line: 89,
            column: 42
          }
        }],
        line: 89
      },
      "13": {
        loc: {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        }, {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        }],
        line: 98
      },
      "14": {
        loc: {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 98,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 98,
            column: 29
          }
        }, {
          start: {
            line: 98,
            column: 33
          },
          end: {
            line: 98,
            column: 65
          }
        }],
        line: 98
      },
      "15": {
        loc: {
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 109,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 109,
            column: 7
          }
        }, {
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 109,
            column: 7
          }
        }],
        line: 105
      },
      "16": {
        loc: {
          start: {
            line: 114,
            column: 49
          },
          end: {
            line: 114,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 114,
            column: 49
          },
          end: {
            line: 114,
            column: 56
          }
        }, {
          start: {
            line: 114,
            column: 60
          },
          end: {
            line: 114,
            column: 65
          }
        }],
        line: 114
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0],
      "8": [0],
      "9": [0],
      "10": [0],
      "11": [0],
      "12": [0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Transfer/Transfer.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import Btns from './btns';
import { PureComponent } from '../component';
import Card from './Card';
import { transferClass } from './styles';
import Context from './context';
import splitSelecteds from './select';
import { isRTL } from '../config';
import getDataset from '../utils/dom/getDataset';
var DefaultProps = (cov_2g6iiaykxs.s[0]++, {
  titles: [],
  data: [],
  footers: [],
  operations: [],
  operationIcon: true,
  renderItem: function renderItem(d) {
    cov_2g6iiaykxs.f[0]++;
    cov_2g6iiaykxs.s[1]++;
    return d;
  },
  rowsInView: 20,
  lineHeight: 32,
  listHeight: 180
});

var Transfer =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Transfer, _PureComponent);

  var _super = _createSuper2(Transfer);

  function Transfer(props) {
    var _this;

    _classCallCheck(this, Transfer);

    cov_2g6iiaykxs.f[1]++;
    cov_2g6iiaykxs.s[2]++;
    _this = _super.call(this, props);
    cov_2g6iiaykxs.s[3]++;
    _this.state = {
      selecteds: props.selectedKeys ? (cov_2g6iiaykxs.b[0][0]++, splitSelecteds(props.selectedKeys, props)) : (cov_2g6iiaykxs.b[0][1]++, (cov_2g6iiaykxs.b[1][0]++, splitSelecteds(props.defaultSelectedKeys, props)) || (cov_2g6iiaykxs.b[1][1]++, [[], []]))
    };
    cov_2g6iiaykxs.s[4]++;
    _this.getSelected = _this.getSelected.bind(_assertThisInitialized(_this));
    cov_2g6iiaykxs.s[5]++;
    _this.setSelecteds = _this.setSelecteds.bind(_assertThisInitialized(_this));
    cov_2g6iiaykxs.s[6]++;
    _this.getLoading = _this.getLoading.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Transfer, [{
    key: "getLoading",
    value: function getLoading(index) {
      cov_2g6iiaykxs.f[2]++;

      var _ref = (cov_2g6iiaykxs.s[7]++, this.props),
          loading = _ref.loading;

      cov_2g6iiaykxs.s[8]++;

      if (Array.isArray(loading)) {
        cov_2g6iiaykxs.b[2][0]++;
        cov_2g6iiaykxs.s[9]++;
        return loading[index];
      } else {
        cov_2g6iiaykxs.b[2][1]++;
      }

      cov_2g6iiaykxs.s[10]++;
      return loading;
    }
  }, {
    key: "getSelected",
    value: function getSelected() {
      cov_2g6iiaykxs.f[3]++;
      cov_2g6iiaykxs.s[11]++;

      if ('selectedKeys' in this.props) {
        cov_2g6iiaykxs.b[3][0]++;
        cov_2g6iiaykxs.s[12]++;
        return splitSelecteds((cov_2g6iiaykxs.b[4][0]++, this.props.selectedKeys) || (cov_2g6iiaykxs.b[4][1]++, []), this.props);
      } else {
        cov_2g6iiaykxs.b[3][1]++;
      }

      cov_2g6iiaykxs.s[13]++;
      return this.state.selecteds;
    }
  }, {
    key: "setSelecteds",
    value: function setSelecteds(index, value) {
      cov_2g6iiaykxs.f[4]++;

      var _ref2 = (cov_2g6iiaykxs.s[14]++, this.props),
          onSelectChange = _ref2.onSelectChange;

      var _ref3 = (cov_2g6iiaykxs.s[15]++, this.state),
          selecteds = _ref3.selecteds;

      var newSelecteds = (cov_2g6iiaykxs.s[16]++, index ? (cov_2g6iiaykxs.b[5][0]++, [selecteds[0], value]) : (cov_2g6iiaykxs.b[5][1]++, [value, selecteds[1]]));
      cov_2g6iiaykxs.s[17]++;

      if (onSelectChange) {
        cov_2g6iiaykxs.b[6][0]++;
        cov_2g6iiaykxs.s[18]++;
        onSelectChange(newSelecteds[0], newSelecteds[1]);
      } else {
        cov_2g6iiaykxs.b[6][1]++;
      }

      cov_2g6iiaykxs.s[19]++;
      this.setState({
        selecteds: newSelecteds
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_2g6iiaykxs.f[5]++;

      var _ref4 = (cov_2g6iiaykxs.s[20]++, this.props),
          _ref4$titles = _ref4.titles,
          titles = _ref4$titles === void 0 ? (cov_2g6iiaykxs.b[7][0]++, DefaultProps.titles) : _ref4$titles,
          data = _ref4.data,
          datum = _ref4.datum,
          keygen = _ref4.keygen,
          renderItem = _ref4.renderItem,
          _ref4$footers = _ref4.footers,
          footers = _ref4$footers === void 0 ? (cov_2g6iiaykxs.b[8][0]++, DefaultProps.footers) : _ref4$footers,
          _ref4$operations = _ref4.operations,
          operations = _ref4$operations === void 0 ? (cov_2g6iiaykxs.b[9][0]++, DefaultProps.operations) : _ref4$operations,
          operationIcon = _ref4.operationIcon,
          className = _ref4.className,
          style = _ref4.style,
          listClassName = _ref4.listClassName,
          listStyle = _ref4.listStyle,
          onFilter = _ref4.onFilter,
          onSearch = _ref4.onSearch,
          empty = _ref4.empty,
          disabled = _ref4.disabled,
          itemClass = _ref4.itemClass,
          _ref4$rowsInView = _ref4.rowsInView,
          rowsInView = _ref4$rowsInView === void 0 ? (cov_2g6iiaykxs.b[10][0]++, DefaultProps.rowsInView) : _ref4$rowsInView,
          _ref4$lineHeight = _ref4.lineHeight,
          lineHeight = _ref4$lineHeight === void 0 ? (cov_2g6iiaykxs.b[11][0]++, DefaultProps.lineHeight) : _ref4$lineHeight,
          _ref4$listHeight = _ref4.listHeight,
          listHeight = _ref4$listHeight === void 0 ? (cov_2g6iiaykxs.b[12][0]++, DefaultProps.listHeight) : _ref4$listHeight,
          renderFilter = _ref4.renderFilter,
          children = _ref4.children;

      var selecteds = (cov_2g6iiaykxs.s[21]++, this.getSelected());
      var datumValues = (cov_2g6iiaykxs.s[22]++, datum.getValue()); // use this.props.value prioritized

      cov_2g6iiaykxs.s[23]++;

      if ((cov_2g6iiaykxs.b[14][0]++, 'value' in this.props) && (cov_2g6iiaykxs.b[14][1]++, datumValues !== this.props.value)) {
        cov_2g6iiaykxs.b[13][0]++;
        cov_2g6iiaykxs.s[24]++;
        this.props.datum.setValue(this.props.value);
      } else {
        cov_2g6iiaykxs.b[13][1]++;
      }

      var sources = (cov_2g6iiaykxs.s[25]++, []);
      var targets = (cov_2g6iiaykxs.s[26]++, []);
      cov_2g6iiaykxs.s[27]++;

      for (var i = 0; i < data.length; i++) {
        var d = (cov_2g6iiaykxs.s[28]++, data[i]);
        cov_2g6iiaykxs.s[29]++;

        if (datum.check(d)) {
          cov_2g6iiaykxs.b[15][0]++;
          cov_2g6iiaykxs.s[30]++;
          targets.push(d);
        } else {
          cov_2g6iiaykxs.b[15][1]++;
          cov_2g6iiaykxs.s[31]++;
          sources.push(d);
        }
      }

      cov_2g6iiaykxs.s[32]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: classnames(transferClass('_', (cov_2g6iiaykxs.b[16][0]++, isRTL()) && (cov_2g6iiaykxs.b[16][1]++, 'rtl')), className),
          style: style
        }, getDataset(this.props), {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 113,
            columnNumber: 7
          }
        }),
        /*#__PURE__*/
        React.createElement(Context.Provider, {
          value: {
            selecteds: selecteds,
            setSelecteds: this.setSelecteds,
            itemClass: itemClass
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 118,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(Card, {
          title: titles[0],
          selecteds: selecteds[0],
          data: sources,
          keygen: keygen,
          renderItem: renderItem,
          setSelecteds: this.setSelecteds,
          index: 0,
          footer: footers[0],
          listClassName: listClassName,
          listStyle: listStyle,
          loading: this.getLoading(0),
          onFilter: onFilter,
          empty: empty,
          disabled: disabled,
          onSearch: onSearch,
          rowsInView: rowsInView,
          lineHeight: lineHeight,
          listHeight: listHeight,
          renderFilter: renderFilter,
          customRender: children,
          values: datumValues,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 119,
            columnNumber: 11
          }
        }),
        /*#__PURE__*/
        React.createElement(Btns, {
          selecteds: selecteds,
          datum: datum,
          setSelecteds: this.setSelecteds,
          keygen: keygen,
          sources: sources,
          targets: targets,
          operations: operations,
          operationIcon: operationIcon,
          data: data,
          disabled: disabled,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 142,
            columnNumber: 11
          }
        }),
        /*#__PURE__*/
        React.createElement(Card, {
          title: titles[1],
          selecteds: selecteds[1],
          data: targets,
          keygen: keygen,
          renderItem: renderItem,
          loading: this.getLoading(1),
          setSelecteds: this.setSelecteds,
          index: 1,
          footer: footers[1],
          listClassName: listClassName,
          listStyle: listStyle,
          onFilter: onFilter,
          empty: empty,
          disabled: disabled,
          onSearch: onSearch,
          rowsInView: rowsInView,
          lineHeight: lineHeight,
          listHeight: listHeight,
          renderFilter: renderFilter,
          customRender: children,
          values: datumValues,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 154,
            columnNumber: 11
          }
        })))
      );
    }
  }]);

  return Transfer;
}(PureComponent);

Transfer.defaultProps = DefaultProps;
export default Transfer;